import { render } from "./tab-bar.vue?vue&type=template&id=4bcda77e"
import script from "./tab-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-bar.vue?vue&type=script&setup=true&lang=js"

import "./tab-bar.vue?vue&type=style&index=0&id=4bcda77e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/main-layout/components/tab-bar/tab-bar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bcda77e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bcda77e', __exports__)) {
    api.reload('4bcda77e', __exports__)
  }
  
  module.hot.accept("./tab-bar.vue?vue&type=template&id=4bcda77e", () => {
    api.rerender('4bcda77e', render)
  })

}


export default __exports__